import mirrorCreator from 'mirror-creator';

////////////////// EDIT //////////////////

const actionTypes = mirrorCreator([
  'UPDATE_INPUT_FIELD',
  'SEND_TO_SERVER',
  'FILL_INFO_QA',
  'SHOW_SUBMIT_BUTTON',
]);

export default actionTypes;
